import common from "@/util/common";
import {MessageBox} from 'mint-ui';

const ax = require('axios');

ax.defaults.withCredentials = true

let VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
// console.log(VUE_APP_BASE_URL);

ax.interceptors.request.use(
    (config) => {
        // console.log(config, '====>config')
        config.headers["source-web"] = "xinhua";

        return config;
    },
    (error) => {
        //request err
        return error;
    }
);


let request = async function (method, path, query, body, alertMsg = true) {
    let r = await ax({
        baseURL: VUE_APP_BASE_URL,
        method: method,
        url: path,
        params: query,
        data: body,
    }).catch(() => {
        // alert(e);
        MessageBox({
            title: '提示',
            message: '请求失败, 请稍后再试',
        })
    })

    let resp = r.data;

    if (resp.rtn === 30007) {//重新登录
        localStorage.removeItem("xinhuaUser");
        common.removeToken()
        // console.log("get token:", common.getCookie("xinhuaToken"));
        MessageBox({
            title: '提示',
            message: resp.errMsg,
        }).then(() => {
            // window.location.href = '/login';
            return
        });

    }

    if (resp.rtn === 1) {
        // 针对图片服务单独处理
        if (path === '/api/tool/snapshot') {
            return MessageBox({
                title: '提示',
                message: resp.errMsg,
            })
        }
    }



    if (resp.rtn && alertMsg) {
        return MessageBox({
            title: '提示',
            message: resp.errMsg,
        }).then(() => {
            return;
        });
    }

    return resp.data;
}

export default {
    get: async function (path, query, body, alertMsg = true) {
        return await request('get', path, query, body, alertMsg);
    },

    post: async function (path, data) {
        return await request('post', path, {}, data);
    },

    put: async function (path, data) {
        return await request('put', path, {}, data);
    },

    delete: async function (path, data) {
        return await request('delete', path, {}, data);
    },

    login: async function (data) {
        return this.post('/api/user/login', data);
    },
    userInfo: async function (data) {
        return this.get('/api/user/info', data);
    },
    getSearchHistory: async function () {
        return this.get('/api/search/history');
    },
    clearSearchHistory: async function () {
        return this.get('/api/search/clearhistory');
    },

    getHotSearch: async function () {
        return this.get('/api/search/hot');
    },

    search: async function (data) {
        return this.get(`/api/search`, data);
    },
    //首页
    getIndustry: async function (name) {
        return this.get(`/api/industry/${name}`);
    },
    //关注列表
    getCompanyList: async function () {
        return this.get(`/api/user/concern/company`);
    },
    concern: async function (company) {
        return this.post(`/api/user/concern`, {company});
    },
    unconcern: async function (company) {
        return this.delete(`/api/user/concern/${company}`);
    },
    //关注推荐相似
    getSimilar: async function () {
        return this.get(`/api/user/similar`);
    },
    //我的企业
    getCompany: async function () {
        return this.get(`/api/user/subscribe/company`);
    },

    //内容风险详情
    contentRisk: async function (data) {
        return this.get(`/api/event/contentRisk`, data);
    },
    // 获取内容风险标签
    getContentRisk: async function (data) {
        return this.get(`/api/chief/contentRisk`, data);
    },

    companyContentRisk: async function (name) {
        return this.get(`/api/event/contentRisk/company/${name}`);
    },

    //行业敏感事件
    riskEvent: async function (data) {
        return this.get(`/api/event`, data);
    },

    //行业 & 子行业 & 企业，主新闻
    getChief: async function (data) {
        return this.get(`/api/chief`, data);
    },

    getChiefDetail: async function (id) {
        return this.get(`/api/chief/` + id);
    },

    getMyCompany: async function () {
        return this.get(`/api/company/my`);
    },

    //企业详情
    company: async function (name, query) {
        return this.get(`/api/company/${name}`, query);
    },

    // 预警列表
    alertList: async function (company, sort) {
        return this.get(`/api/event?company=${company}&tendency=负面&sort=${sort}`);
    },
    //事件详情
    getEventDetail: async function (id) {
        return this.get(`/api/warning/${id}/event`);
    },
    //对比
    compare: async function (data) {
        return this.get(`/api/compare`, data);
    },

    //企业舆情健康指数排行榜
    healthRank: async function (data) {
        return this.get(`/api/industry/healthRank`, data);
    },
    healthRankNew: async function (data) {
        return this.get(`/api/industry/aggHealthRank?`, data);
    },
    //下属机构健康度
    subCompanyHealth: async function (data) {
        return this.get(`/api/company/subCompanyHealth`, data);
    },

    //涉企高管报道
    managerReport: async function (data) {
        return this.get(`/api/industry/managerReport`, data);
    },
    //媒体站点报道倾向
    mediaReport: async function (data) {
        return this.get(`/api/industry/mediaReport`, data);
    },
    /* 截图
    body: {
      "url": "http://fengsheng.focuxy.com/companyReport/%E4%B8%AD%E5%9B%BD%E5%B9%B3%E5%AE%89",
      "fileName": "中国平安日报"
    }
    response:
    {
        "rtn": 0,
        "data": {
            "fileUrl": "/snapshot/中国平安日报-2020-12-15_17:30:43.jpg"
        }
    }
     */

    sendEmail: async function (data) {
        return this.post(`/api/tool/sendEmail`, data);
    },

    warning: async function (data) {
        return this.get(`/api/chief/list`, data);
    },

    contentRiskIndustry: async function (name) {
        return this.get(`/api/event/contentRisk/industry/${name}`);
    },
    createReport: async function (body) {
        return this.post(`/api/report`, body);
    },
    updateReport: async function (id) {
        return this.put(`/api/report/${id}`);
    },
    getReports: async function (query) {
        return this.get(`/api/report`, query);
    },
    getReportInfo: async function (query) {
        return this.get(`/api/report/info`, query);
    },
    getReport: async function (id) {
        return this.get(`/api/report/${id}`);
    },
    delReport: async function (id) {
        return this.delete(`/api/report/${id}`);
    },

    rank: async function (query) {
        return this.get(`/api/rank`, query);
    },
    // 网络口碑
    getWebKeyword: async function (name) {
        return this.get(`/api/iwom/${name}`, {}, {}, false);
    },

    getArticle: async function (query) {
        return this.get(`/api/article`, query);
    },
    createAddress: async function (data) {
        return this.post( '/api/address', data)
    },
    eidtAddress: async function (id, data) {
        return this.put( `/api/address/${id}`, data)
    },
    deleteAddress: async function (id) {
        return this.delete( `/api/address/${id}`)
    },
}